import React from 'react';
import { EngineCommercialA4Print } from '@/components/print/EngineCommercialPrints';
import {
  buildEpcProposalPrintLines,
  buildEpcProposalPrintMeta,
  type EpcProposalPrintBundle,
} from '@/utils/epcProposalPrint';
import { formatMoney } from '@/utils/format';

export interface PrintableEpcProposalProps {
  bundle: EpcProposalPrintBundle;
  onClose?: () => void;
}

export const PrintableEpcProposal: React.FC<PrintableEpcProposalProps> = ({ bundle, onClose }) => {
  const p = bundle.proposal;
  const currency = String(p.currency || bundle.tender.currency || 'AED');
  const value = Number(p.commercial_value ?? p.commercialValue);

  return (
    <EngineCommercialA4Print
      docType="epc_proposal"
      title="EPC COMMERCIAL PROPOSAL"
      documentNumber={String(p.proposal_number || p.title || 'PROPOSAL')}
      partyName={String(bundle.tender.client_name || bundle.tender.clientName || bundle.tender.title || '')}
      onClose={onClose}
      landscape
      metaLines={buildEpcProposalPrintMeta(bundle)}
      introText="Technical completeness, commercial terms, deviations, and estimate basis for customer submission."
      columns={[
        { key: 'sno', label: '#' },
        { key: 'type', label: 'Type' },
        { key: 'description', label: 'Item' },
        { key: 'status', label: 'Status' },
        { key: 'detail', label: 'Detail' },
      ]}
      lines={buildEpcProposalPrintLines(bundle)}
      finals={[{ id: 'totals', heightPx: 72 }]}
      finalBlocks={{
        totals: (
          <div className="print-letter-totals">
            <table>
              <tbody>
                <tr>
                  <td>Estimate basis :</td>
                  <td>{String(bundle.basisStatus || '—')}</td>
                </tr>
                <tr className="grand-total">
                  <td>Commercial bid value :</td>
                  <td>
                    {Number.isFinite(value)
                      ? formatMoney(value, {
                          currency,
                          locale: 'en-US',
                          display: 'code_prefix',
                          separator: ' ',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })
                      : '—'}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ),
      }}
    />
  );
};
